@if (showVerifyEmailMessage) {
  <div class="verify-email-message-box" [ngClass]="sideMenuIsOpen ? 'compact' : 'full'">
    <div class="content center-text">
      <span [innerHtml]="'registration.verifyYourEmailPart1' | translate"></span>
      @if (!emailSendingInProgress) {
        <span class="clickable underlined m-l-4" [innerHtml]="'registration.verifyYourEmailPart2' | translate" (click)="resendVerificationEmail()"></span>
      }
      @if (emailSendingInProgress) {
        <span class="m-l-4" [innerHtml]="'registration.verifyYourEmailProgress' | translate"></span>
      }
    </div>
    <div class="close">
      <span class="float-right clickable" (click)="closeMessageBox()"><mat-icon class="font-18">close</mat-icon></span>
    </div>
  </div>
}
